import {
  BackendServerActionType,
  BodyModel,
  ButtonElementModel,
  ButtonPanelElementModel,
  ColumnHeaderElementModel,
  ConditionPanelElementModel,
  DevelopConditionListViewScript,
  DevelopScriptServicePack,
  EditType,
  InputDateBetweenElementModel,
  InputPartsBaseModel,
  LinkElementModel,
  ListPanelElementModel,
  PanelModel,
  PanelType,
  RowCellElementModel,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';
import { ApplicationUserUtility } from 'src/app/utility/application-user-utility';
import { ConvertLabelAndValueList, OrderSheetFormat } from '../const/ordersheet-issue-const';

export class OrderSheetConditionList implements DevelopConditionListViewScript {
  scriptName: string = 'OrderSheetConditionList';

  /**
   * 初期処理
   * @param panelModels
   * @param service
   */
  init(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    this.setupRelationalLabel(panelModels);
    this.setInitConditionData(panelModels, service);
    this.setupCreateButton(panelModels, service);
  }

  /**
   * 新規登録ボタンの表示、非表示を設定
   * @param panelModels
   * @param service
   */
  setupCreateButton(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    if (ApplicationUserUtility.loginUserIsLegal()) {
      const buttonPanel = panelModels.get(PanelType.FooterButtonPanel) as ButtonPanelElementModel;
      buttonPanel.leftButtons.forEach((button) => {
        if (button.id === 'CreateButton') {
          button.class = ['hidden'];
        }
      });
    }
  }
  /**
   * 検索条件の初期値を設定
   * @param panelModels
   * @param service
   */
  setInitConditionData(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {
    const conditionPanel = panelModels.get(PanelType.ConditionPanel) as ConditionPanelElementModel;
    const setOrderDate = () => {
      let today = new Date();
      let threeMonthAgo = new Date();
      threeMonthAgo.setMonth(today.getMonth() - 3);

      conditionPanel.inputPartsList.forEach((inputParts) => {
        if (inputParts.id === 'OrderDate') {
          const dateBetween = inputParts as InputDateBetweenElementModel;
          dateBetween.to.date = today;
          dateBetween.to.value = today;

          dateBetween.from.date = threeMonthAgo;
          dateBetween.from.value = threeMonthAgo;
        }
      });
    };

    setOrderDate();
  }
  /**
   * 一覧における関連するデータを表示する際に使用するラベルを設定
   * @param panelModels
   */
  setupRelationalLabel(panelModels: Map<PanelType, PanelModel>): void {
    // NOTE: 初期処理でrelationalListKeysに値を埋め込むと、バックエンドサーバーからデータを取得する処理が発生するため、setTimeoutで遅延させている
    setTimeout(() => {
      const listPanel = panelModels.get(PanelType.ListPanel) as ListPanelElementModel;
      listPanel.listElementModel.headerModel.headers.forEach((header) => {
        if (header.columnName === 'OrderSheetFormat') {
          header.relationalListKeys = ['OrderSheetFormat'];
          header.relationalListMap = {
            OrderSheetFormat: ConvertLabelAndValueList(OrderSheetFormat),
          };
        }
      });
    }, 10);
  }
  /**
   * 終了処理
   * @param panelModels
   * @param service
   */
  destroy(panelModels: Map<PanelType, PanelModel>, service: DevelopScriptServicePack): void {}

  /**
   * データ取得後の処理
   * @param bodyModel
   * @param headers
   */
  fetchedList(bodyModel: BodyModel, headers: ColumnHeaderElementModel[]): void {
    const isPending = (row: RowCellElementModel) => {
      const isOnairDateCommitedCells = row.cells.filter((cell) => cell.columnName === 'IsOnairDateCommited');
      const isPriceCommitedCells = row.cells.filter((cell) => cell.columnName === 'IsPriceCommited');
      return !(isOnairDateCommitedCells[0].cellModel.value && isPriceCommitedCells[0].cellModel.value);
    };

    bodyModel.rows.forEach((row) => {
      row.cells
        .filter((cell) => cell.columnName === 'StatusName')
        .forEach((cell) => {
          if (isPending(row) && cell.cellModel.value === '受領済') {
            cell.cellModel.class.push('received-pending');
          } else if (isPending(row)) {
            cell.cellModel.class.push('pending');
          } else if (cell.cellModel.value === '受領済') {
            cell.cellModel.class.push('received');
          }
          // 発注書データが「受領済+未定あり」の場合、それぞれにスタイルを付ける必要があるので表示させる文字はvalueではなくCSSで指定する。
          cell.cellModel.value = '';
        });
    });
  }

  /**
   * バリデーションチェック
   * @param targetValidationPanel
   * @param actionType
   * @param panelModels
   * @param service
   */
  validationCheck(
    targetValidationPanel: PanelType,
    actionType: BackendServerActionType,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): boolean {
    return true;
  }

  /**
   * ボタン押下処理
   * @param panelModels
   * @param clickedButtonElement
   * @param service
   */
  clickedButton(
    panelModels: Map<PanelType, PanelModel>,
    clickedButtonElement: ButtonElementModel,
    service: DevelopScriptServicePack
  ): void {
    if (clickedButtonElement.id == 'CreateButton') {
      service.moveViewService.moveViewInGocooEngine(ViewType.GroupEdit, 'OrderSheet', EditType.New, {});
    }
  }

  /**
   * リンク押下処理
   * @param panelModels
   * @param clickedLinkElement
   * @param service
   */
  clickedLink(
    panelModels: Map<PanelType, PanelModel>,
    clickedLinkElement: LinkElementModel,
    service: DevelopScriptServicePack
  ): void {}

  /**
   * 入力イベント処理
   * @param inputPartsModel
   * @param panelModels
   * @param service
   */
  inputPartsEvent(
    inputPartsModel: InputPartsBaseModel,
    panelModels: Map<PanelType, PanelModel>,
    service: DevelopScriptServicePack
  ): void {
    throw new Error('Method not implemented.');
  }
}
